import React, { useRef, useState } from "react";
import SvgIcon from "./SvgIcon";
import _ from "lodash";
import PropTypes from "prop-types";
import getAvatarUrl from "../utils/get-avatar-url";
import { NOTIFICATIONS } from "../constants";
import useClickOutside from "../hooks/useClickOutside";
import submit from "submit-form";

const { ICONS } = NOTIFICATIONS;
const NotificationsDropdown = ({ mobile = false }, { locals }) => {
  const { listNotifications, activeUser, momentTZ } = locals;

  const dropdownRef = useRef(null);
  const athletes = locals.activeUser.athletes || [];
  const unread = _.size(_.reject(listNotifications, "read"));
  const [notificationsOpened, setNotificationsOpened] = useState(false);
  useClickOutside(
    dropdownRef,
    () => {
      setNotificationsOpened(false);
    },
    notificationsOpened
  );

  const markAsRead = (id, path) => {
    submit(`/actions/notification/read/${id}`, {
      method: path ? "POST" : "GET",
      body: { redirectPath: path },
    });
  };
  const checkNameOnText = (
    notificationText,
    athleteName,
    isAthlete = false
  ) => {
    if (notificationText.startsWith(athleteName) || isAthlete)
      return notificationText;
    const notificationWords = notificationText.split(" ");

    const removed = notificationWords.splice(0, 2, athleteName);
    return notificationWords.join(" ");
  };
  let isAthlete = false;
  if (activeUser.coach) isAthlete = true;
  const NotificationContent = ({ notification }) => {
    const notificationText = notification.text;
    const athlete = athletes.find(
      (element) => element._id === notification.requesterId
    );
    const athleteName = athlete?.name;

    return (
      <>
        <SvgIcon
          src={NotificationProfilePicture({
            notification,
            activeUser,
            athlete,
          })}
          noFilterOnLight={true}
        />
        <div>
          <div>
            <b>{athleteName}</b>
            <time>{momentTZ(notification.date).format("MMM D, YYYY")}</time>
          </div>
          <div>
            <span>
              {checkNameOnText(notificationText, athleteName, isAthlete)}
            </span>
          </div>
        </div>
      </>
    );
  };
  const NotificationItem = ({ notification }) => {
    return (
      <>
        {notification.button && !notification.read ? (
          <a
            // href={notification.button.link
            //   .replace("http://app.mystrengthbook.com", "")
            //   .replace("https://app.mystrengthbook.com", "")}
            // target={
            //   _.get(notification, "button.newTab", false) ? `_blank` : `_self`
            // }
            onClick={() => {
              setNotificationsOpened(false);
              markAsRead(
                notification._id,
                notification.button.link
                  .replace("http://app.mystrengthbook.com", "")
                  .replace("https://app.mystrengthbook.com", "")
              );
            }}
          >
            <NotificationContent notification={notification} />
          </a>
        ) : notification.button && notification.read ? (
          <a
            href={notification.button.link
              .replace("http://app.mystrengthbook.com", "")
              .replace("https://app.mystrengthbook.com", "")}
            target={
              _.get(notification, "button.newTab", false) ? `_blank` : `_self`
            }
          >
            <NotificationContent notification={notification} />
          </a>
        ) : !notification.button && !notification.read ? (
          <a
            onClick={() => {
              setNotificationsOpened(false);
              markAsRead(notification._id);
            }}
          >
            <NotificationContent notification={notification} />
          </a>
        ) : (
          <a
            href="#"
            onClick={() => {
              setNotificationsOpened(false);
            }}
          >
            <NotificationContent notification={notification} />
          </a>
        )}
        {!notification.read && <div className="unread" />}
      </>
    );
  };
  return (
    <details
      id="notification-dropdown"
      role="list"
      tabIndex="-1"
      ref={dropdownRef}
      open
    >
      <summary
        aria-haspopup="listbox"
        onClick={(e) => {
          e.preventDefault();
          setNotificationsOpened(!notificationsOpened);
        }}
      >
        <SvgIcon src="/img/new-icons/notification-bell.svg" />
        {unread > 0 && <div className="unread-nots-badge"></div>}
      </summary>
      <div className={`${notificationsOpened ? "opened" : ""}`}>
        <header>
          <h5>Notifications</h5>
          {unread > 0 && (
            <a
              role="button"
              data-button-type="secondary"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                submit(`/actions/notification/read-all`, {
                  method: "GET",
                });
              }}
            >
              <b>Mark All As Read</b>
            </a>
          )}
        </header>
        {listNotifications &&
        Array.isArray(listNotifications) &&
        listNotifications.length > 0 ? (
          <ul role="listbox">
            {_(listNotifications)
              .take(5)
              .map((notification) => {
                return (
                  <li key={notification._id}>
                    <NotificationItem notification={notification} />
                  </li>
                );
              })
              .value()}
          </ul>
        ) : (
          <div className="no-notifications">
            <span>You don’t have any notifications.</span>
          </div>
        )}
        {listNotifications &&
          Array.isArray(listNotifications) &&
          listNotifications.length > 0 && (
            <footer>
              <a
                href={
                  isAthlete
                    ? "/dashboard/notifications"
                    : "/coaching-portal/notifications"
                }
                role="button"
                data-button-type="secondary"
                onClick={() => setNotificationsOpened(false)}
              >
                See All Notifications
                <SvgIcon src="/img/new-icons/arrow-right.svg" />
              </a>
            </footer>
          )}
      </div>
    </details>
  );
};
function NotificationProfilePicture({ activeUser, notification, athlete }) {
  const hasImage = notification.requesterId && activeUser.athletes;
  return hasImage
    ? getAvatarUrl(athlete, null, activeUser.webAppTheme)
    : _.get(ICONS, notification.type, ICONS.Default);
}
NotificationsDropdown.contextTypes = { locals: PropTypes.object };

export default NotificationsDropdown;
